
import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class FormsTabContainer {
	constructor(el) {
		console.log(`FormsTabContainer el = `, el);
		this.el = el;
		this.dojoId = parseInt(el.getAttribute('dojo-id'));
		this.refType = el.getAttribute('ref-type');
		this.refId = parseInt(el.getAttribute('ref-id'));


		this.tabs = this.el.querySelector(`#tabs`);

		Promise.all(
			[
			DojoDeshi.instance().RPC().FormsAndInputsForDojoRefType(this.dojoId, this.refType, this.refId),
			]
		).then(
			(res)=>{
				let forms = res[0][0];
				let inputs = res[0][1];

				let appendPanel = (panel, title)=>{
					console.log(`appendPanel(title= ${title}, panel=`, panel); 
					this.tabs.addPanel(panel, title, true);
				};				

				for (let i=0; i<forms.length; i++) {
					let form = forms[i];
					let input = inputs[i];


					new FormsTabPanel(appendPanel, 
						form.Name, form.Title, form.Definition, 
						input.Input, 
						(data)=> {
							return new Promise( (resolve,reject)=> {
								console.log("Saving data for form ", form);
								console.log('data = ', data);
								input.Input = data;
								console.log("Input = ", input);
								DojoDeshi.instance().RPC().SaveFormInput(input).then(
									(res)=>{
										resolve(true);
									}, (err)=>{
										reject(err);
									}).catch( (err)=> {
										reject(err);
									});
							});
						}
					);
				}
				// Foundation.reInit(['tabs']);
				// Foundation.reflow(jQuery(el), ['tabs']);
				// jQuery(el).foundation('tabs');
			}
		).catch(
			(err)=>{
				console.error(err);
				alert(`ERROR: ${err.message}`);
			}
		);
	}
}

window.FormsTabContainer = FormsTabContainer;